import {IntermediatePart} from "../../parts/intermediatePart";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {Shower} from "../../parts/shower";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import store from "../../../../../store";
import {toggleNotCompatibleView} from "../../../../../actions/selectionFunctions";
import {ShowerComboTubType} from "../../constants";

export default class ShowerFixture extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_fixture';
    this.partName = 'Fixture';
    this.translateId = "visualizer.bathroom.shower.shower_fixture";
    this.homePageTitle = 'Shower Fixtures';
    this.dbName = 'Shower Fixture';
    this.layerPriority = 4;
    if (isChild) {
      this.previouslySelectedFeatures = {
        LG: {},
        SM: {}
      };
    }
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ShowerFixture());
  }

  setLayers(layout) {

    const showerTubCombo = this.getParent().layout.parts[ShowerTubCombo.id];

    if (this.getParent().showerTubComboIsActive() && showerTubCombo && showerTubCombo.walkInTub
      && showerTubCombo.bottomTub === showerTubCombo.walkInTub.bottomTubId) {
      super.hideLayers();
      return;
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    if (shower.layout && shower.showerTubComboIsActive()
      && shower.layout.parts[ShowerTubCombo.id].bottomTub === ShowerComboTubType.walk_in_tub) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
      comboPart.bottomTub = ShowerComboTubType.bathtub_liner;
    }
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked); // set active item & not in visualizer item
    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }

    const showerFixtureParent = this.getParent();
    const shower = showerFixtureParent.getParent();
    if (shower.showerTubComboIsActive() && shower.layout.parts[ShowerTubCombo.id].bottomTub === ShowerComboTubType.walk_in_tub
      && !window.location.hash.includes("visualizer")) {
      store.dispatch(toggleNotCompatibleView(true));
      return;
    }

    this.applyFeatureIfNotCompatible();
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    const activeShowerPartId = showerParent.showerTubComboIsActive() ? ShowerTubCombo.id : Shower.id;
    const showerSize = showerParent.layout.parts[activeShowerPartId].showerSize();
    return [{
      propName: "Shower",
      propValue: showerParent.showerTubComboIsActive()
      && (showerParent.layout.parts[activeShowerPartId].bottomTub !== ShowerComboTubType.walk_in_tub)
        ? ["Tub"]
        : showerParent.isComplete() ? "Complete" : "Custom"
    }, {
      propName: 'ShowerSize',
      propValue: showerSize
    }]
  }

  setDefault() {
    const shower = this.getParent();
    const currentActiveFeature = this.activeFeature;
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      this.setDefaultAccordingToPreviousSelect(shower, filteredFeatures, "Brantford");
    }
    this.rememberPreviousSelection(shower, currentActiveFeature);
  }

  setZIndex(zIndexes) {
    const ShowerType = this.getParent().activeSubType() === Shower.Type.Custom || this.getParent().showerTubComboIsActive()
      ? 'Custom60in'
      : 'Steam60in';
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Shower[ShowerType].Fixture;
    }
    if(zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndexes.Shower[ShowerType].Fixture;
    }
  }
}
